import { render } from "./TitleSectionBlock.vue?vue&type=template&id=28b86b46&scoped=true"
import script from "./TitleSectionBlock.vue?vue&type=script&lang=js"
export * from "./TitleSectionBlock.vue?vue&type=script&lang=js"

import "./TitleSectionBlock.vue?vue&type=style&index=0&id=28b86b46&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b86b46"]])

export default __exports__